import {
  RESET_DATA,
  RESET_SALES,
  SET_HEADER_DATE_FROM,
  SET_HEADER_DATE_TO,
  SET_HEADER_UNIT,
  GET_RECHARGE_DISTRIBUTION_API,
  GET_RECHARGE_DISTRIBUTION_API_SUCCESS,
  GET_RECHARGE_DISTRIBUTION_API_FAILED,
  GET_RECHARGE_DIST_CSV_API,
  GET_RECHARGE_DIST_CSV_API_SUCCESS,
  GET_RECHARGE_DIST_CSV_API_FAILED,
  GET_RECHARGE_SALES_API,
  GET_RECHARGE_SALES_API_SUCCESS,
  GET_RECHARGE_SALES_API_FAILED,
  GET_RECHARGE_SALES_CSV_API,
  GET_RECHARGE_SALES_CSV_API_SUCCESS,
  GET_RECHARGE_SALES_CSV_API_FAILED,
  GET_SEVEN_DAY_TRANSACTION,
  GET_SEVEN_DAY_TRANSACTION_SUCCESS,
  GET_SEVEN_DAY_TRANSACTION_FAILED,
  GET_SEVEN_DAY_CSV,
  GET_SEVEN_DAY_CSV_SUCCESS,
  GET_SEVEN_DAY_CSV_FAILED,
  GET_RECHARGE_WALLET_BALANCE,
  GET_RECHARGE_WALLET_BALANCE_SUCCESS,
  GET_RECHARGE_WALLET_BALANCE_FAILED,
  GET_RECHARGE_WALLET_BALANCE_CSV,
  GET_RECHARGE_WALLET_BALANCE_SUCCESS_CSV,
  GET_RECHARGE_WALLET_BALANCE_FAILED_CSV,
  GET_TOP_FIVE_RETAILERS,
  GET_TOP_FIVE_RETAILERS_SUCCESS,
  GET_TOP_FIVE_RETAILERS_FAILED,
  GET_BOTTOM_FIVE_RETAILERS,
  GET_BOTTOM_FIVE_RETAILERS_SUCCESS,
  GET_BOTTOM_FIVE_RETAILERS_FAILED,
  GET_RECHARGE_INSIGHTS_API,
  GET_RECHARGE_INSIGHTS_API_SUCCESS,
  GET_RECHARGE_INSIGHTS_API_FAILED,
  SHOW_ALERT,
  HIDE_ALERT,
} from "../actions";
import { getTodaysDate } from "../../utils/common";
import config from "../../utils/config";

export const initialStateRecharge = {
  headerSelectedDateFrom: getTodaysDate(config.startDate),
  headerSelectedDateTo: getTodaysDate(config.endDate),
  getAllAPI: {
    loading: false,
    data: {},
    error: null,
    distributionObject: {},
  },
  distributionObj: {
    loading: false,
    error: null,
    distributionTableData: {},
  },
  distCsvObj: {
    loading: false,
    error: null,
    csvData: {},
  },
  rechCsvLoading: {
    Billed: false,
    OnBoarded: false,
  },
  rechargeSalesObj: {
    loading: false,
    error: null,
    salesData: {},
  },
  rechargeSalesCsvObj: {
    loading: false,
    error: null,
    salesCsvData: {},
  },
  rechargeSalesCsvLoading: {
    RECHARGE: false,
    THROUGH: false,
    DIRECTLY: false,
    ZD: false,
    RDS: false,
    RETAILER: false,
    LAST: false,
  },
  getLastSevenTransaction: {
    loading: false,
    data: {}, //last7day,
    error: null,
  },
  getLastSevenTransactionCSV: {
    loading: false,
    data: {}, //last7dayCSV,
    error: null,
  },
  getRechargeWalletBalance: {
    loading: false,
    data: {}, //walletRecharge,
    error: null,
  },
  getRechargeWalletBalanceCSV: {
    loading: false,
    data: {}, //walletRechargeCSV,
    error: null,
  },
  getTopFiveRetailer: {
    loading: false,
    data: {}, //top5,
    error: null,
  },
  getBottomFiveRetailer: {
    loading: false,
    data: {}, //bottom5,
    error: null,
  },
  rechargeInsights: {
    loading: false,
    error: null,
    data: {},
    loadingKeys: {},
  },
  showAlert: false,
};

export function rechargeSalesReducer(state = initialStateRecharge, action) {
  switch (action.type) {
    case RESET_DATA:
      return {
        ...state,
        distributionObj: {
          loading: false,
          error: null,
          distributionTableData: {},
        },
        rechargeSalesObj: {
          loading: false,
          error: null,
          salesData: {},
        },
        getLastSevenTransaction: {
          loading: false,
          data: {}, //last7day,
          error: null,
        },
        getRechargeWalletBalance: {
          loading: false,
          data: {}, //walletRecharge,
          error: null,
        },
        getTopFiveRetailer: {
          loading: false,
          data: {}, //top5,
          error: null,
        },
        getBottomFiveRetailer: {
          loading: false,
          data: {}, //bottom5,
          error: null,
        },
      };
    case RESET_SALES:
      return {
        ...state,
        rechargeSalesObj: {
          loading: false,
          error: null,
          salesData: {},
        },
        getRechargeWalletBalance: {
          loading: false,
          data: {}, //walletRecharge,
          error: null,
        },
        getTopFiveRetailer: {
          loading: false,
          data: {}, //top5,
          error: null,
        },
        getBottomFiveRetailer: {
          loading: false,
          data: {}, //bottom5,
          error: null,
        },
      };
    case SET_HEADER_DATE_FROM:
      return {
        ...state,
        headerSelectedDateFrom: action.payload,
      };

    case SET_HEADER_DATE_TO:
      return {
        ...state,
        headerSelectedDateTo: action.payload,
      };

    case SET_HEADER_UNIT:
      return {
        ...state,
        headerUnit: action.payload,
      };

    case GET_RECHARGE_DISTRIBUTION_API:
      return {
        ...state,
        distributionObj: {
          loading: true,
          error: null,
          distributionTableData: state.distributionObj.distributionTableData,
        },
      };

    case GET_RECHARGE_DISTRIBUTION_API_SUCCESS:
      let distTable = JSON.parse(
        JSON.stringify(state.distributionObj.distributionTableData),
      );
      distTable[action.extraData] = [action.payload.content];
      return {
        ...state,
        distributionObj: {
          loading: false,
          error: null,
          distributionTableData: Object.assign(
            state.distributionObj.distributionTableData,
            distTable,
          ),
        },
      };

    case GET_RECHARGE_DISTRIBUTION_API_FAILED:
      return {
        ...state,
        distributionObj: {
          loading: false,
          error: action.error,
          distributionTableData: {},
        },
      };
    case GET_RECHARGE_DIST_CSV_API:
      return {
        ...state,
        distCsvObj: {
          loading: true,
          error: null,
          csvData: {},
        },
        rechCsvLoading: {
          ...state.rechCsvLoading,
          [action.tab]: true,
        },
      };

    case GET_RECHARGE_DIST_CSV_API_SUCCESS:
      let distCsv = JSON.parse(JSON.stringify(state.distCsvObj.csvData));
      distCsv[action.extraData + "$" + action.tab] = [action.payload.content];
      return {
        ...state,
        distCsvObj: {
          loading: false,
          error: null,
          csvData: Object.assign(state.distCsvObj.csvData, distCsv),
        },
        rechCsvLoading: {
          ...state.rechCsvLoading,
          [action.tab]: false,
        },
      };
    case GET_RECHARGE_DIST_CSV_API_FAILED:
      return {
        ...state,
        distCsvObj: {
          loading: false,
          error: action.error,
          csvData: {},
        },
        rechCsvLoading: {
          ...state.rechCsvLoading,
          [action.tab]: false,
        },
      };
    case GET_RECHARGE_SALES_API:
      return {
        ...state,
        rechargeSalesObj: {
          loading: true,
          error: null,
          salesData: state.rechargeSalesObj.salesData,
        },
      };

    case GET_RECHARGE_SALES_API_SUCCESS:
      let salesTable = JSON.parse(
        JSON.stringify(state.rechargeSalesObj.salesData),
      );

      salesTable[action.extraData] = [action.payload.content];
      return {
        ...state,
        rechargeSalesObj: {
          loading: false,
          error: null,
          salesData: Object.assign(
            state.rechargeSalesObj.salesData,
            salesTable,
          ),
        },
      };

    case GET_RECHARGE_SALES_API_FAILED:
      return {
        ...state,
        rechargeSalesObj: {
          loading: false,
          error: action.error,
          salesData: {},
        },
      };
    case GET_RECHARGE_SALES_CSV_API:
      return {
        ...state,
        rechargeSalesCsvObj: {
          loading: true,
          error: null,
          salesCsvData: {},
        },
        rechargeSalesCsvLoading: {
          ...state.rechargeSalesCsvLoading,
          [action.tab]: true,
        },
      };

    case GET_RECHARGE_SALES_CSV_API_SUCCESS:
      let salesCsv = JSON.parse(
        JSON.stringify(state.rechargeSalesCsvObj.salesCsvData),
      );
      salesCsv[action.extraData] = [action.payload.content];
      return {
        ...state,
        rechargeSalesCsvObj: {
          loading: false,
          error: null,
          salesCsvData: Object.assign(
            state.rechargeSalesCsvObj.salesCsvData,
            salesCsv,
          ),
        },
        rechargeSalesCsvLoading: {
          ...state.rechargeSalesCsvLoading,
          [action.tab]: false,
        },
      };

    case GET_RECHARGE_SALES_CSV_API_FAILED:
      return {
        ...state,
        rechargeSalesCsvObj: {
          loading: false,
          error: action.error,
          salesCsvData: {},
        },
        rechargeSalesCsvLoading: {
          ...state.rechargeSalesCsvLoading,
          [action.tab]: false,
        },
      };
    case GET_SEVEN_DAY_TRANSACTION:
      return {
        ...state,
        getLastSevenTransaction: {
          loading: true,
          data: state.getLastSevenTransaction.data,
          error: null,
        },
      };

    case GET_SEVEN_DAY_TRANSACTION_SUCCESS:
      return {
        ...state,
        getLastSevenTransaction: {
          loading: false,
          data: Object.assign(
            state.getLastSevenTransaction.data,
            action.payload.content,
          ),
          error: null,
        },
      };

    case GET_SEVEN_DAY_TRANSACTION_FAILED:
      return {
        ...state,
        getLastSevenTransaction: {
          loading: false,
          data: {},
          error: action.error,
        },
      };

    case GET_SEVEN_DAY_CSV:
      return {
        ...state,
        getLastSevenTransactionCSV: {
          loading: true,
          data: {},
          error: null,
        },
        rechargeSalesCsvLoading: {
          ...state.rechargeSalesCsvLoading,
          [action.tab]: true,
        },
      };

    case GET_SEVEN_DAY_CSV_SUCCESS:
      return {
        ...state,
        getLastSevenTransactionCSV: {
          loading: false,
          data: action.payload,
          error: null,
        },
        rechargeSalesCsvLoading: {
          ...state.rechargeSalesCsvLoading,
          [action.tab]: false,
        },
      };

    case GET_SEVEN_DAY_CSV_FAILED:
      return {
        ...state,
        getLastSevenTransactionCSV: {
          loading: false,
          data: {},
          error: action.error,
        },
        rechargeSalesCsvLoading: {
          ...state.rechargeSalesCsvLoading,
          [action.tab]: false,
        },
      };

    case GET_RECHARGE_WALLET_BALANCE:
      return {
        ...state,
        getRechargeWalletBalance: {
          loading: true,
          data: state.getRechargeWalletBalance.data,
          error: null,
        },
      };

    case GET_RECHARGE_WALLET_BALANCE_SUCCESS:
      return {
        ...state,
        getRechargeWalletBalance: {
          loading: false,
          data: Object.assign(
            state.getRechargeWalletBalance.data,
            action.payload.content,
          ),
          error: null,
        },
      };

    case GET_RECHARGE_WALLET_BALANCE_FAILED:
      return {
        ...state,
        getRechargeWalletBalance: {
          loading: false,
          data: {},
          error: action.error,
        },
      };

    case GET_RECHARGE_WALLET_BALANCE_CSV:
      return {
        ...state,
        getRechargeWalletBalanceCSV: {
          loading: true,
          data: {},
          error: null,
        },
        rechargeSalesCsvLoading: {
          ...state.rechargeSalesCsvLoading,
          [action.tab]: true,
        },
      };

    case GET_RECHARGE_WALLET_BALANCE_SUCCESS_CSV:
      return {
        ...state,
        getRechargeWalletBalanceCSV: {
          loading: false,
          data: action.payload,
          error: null,
        },
        rechargeSalesCsvLoading: {
          ...state.rechargeSalesCsvLoading,
          [action.tab]: false,
        },
      };

    case GET_RECHARGE_WALLET_BALANCE_FAILED_CSV:
      return {
        ...state,
        getRechargeWalletBalanceCSV: {
          loading: false,
          data: {},
          error: action.error,
        },
        rechargeSalesCsvLoading: {
          ...state.rechargeSalesCsvLoading,
          [action.tab]: false,
        },
      };

    case GET_TOP_FIVE_RETAILERS:
      return {
        ...state,
        getTopFiveRetailer: {
          loading: true,
          data: state.getTopFiveRetailer.data,
          error: null,
        },
      };

    case GET_TOP_FIVE_RETAILERS_SUCCESS:
      return {
        ...state,
        getTopFiveRetailer: {
          loading: false,
          data: Object.assign(
            state.getTopFiveRetailer.data,
            action.payload.content,
          ),
          error: null,
        },
      };

    case GET_TOP_FIVE_RETAILERS_FAILED:
      return {
        ...state,
        getTopFiveRetailer: {
          loading: false,
          data: {},
          error: action.error,
        },
      };

    case GET_BOTTOM_FIVE_RETAILERS:
      return {
        ...state,
        getBottomFiveRetailer: {
          loading: true,
          data: state.getBottomFiveRetailer.data,
          error: null,
        },
      };

    case GET_BOTTOM_FIVE_RETAILERS_SUCCESS:
      return {
        ...state,
        getBottomFiveRetailer: {
          loading: false,
          data: Object.assign(
            state.getBottomFiveRetailer.data,
            action.payload.content,
          ),
          error: null,
        },
      };

    case GET_BOTTOM_FIVE_RETAILERS_FAILED:
      return {
        ...state,
        getBottomFiveRetailer: {
          loading: false,
          data: {},
          error: action.error,
        },
      };
    case SHOW_ALERT: {
      return {
        ...state,
        showAlert: true,
      };
    }
    case HIDE_ALERT: {
      return {
        ...state,
        showAlert: false,
      };
    }

    case GET_RECHARGE_INSIGHTS_API: {
      const key = action.extraData;
      const loadingKeys =
        key != null
          ? { ...state.rechargeInsights.loadingKeys, [key]: true }
          : state.rechargeInsights.loadingKeys;
      return {
        ...state,
        rechargeInsights: {
          loading: true,
          error: null,
          data: state.rechargeInsights.data,
          loadingKeys,
        },
      };
    }

    case GET_RECHARGE_INSIGHTS_API_SUCCESS: {
      const key = action.extraData;
      const newData =
        key != null
          ? {
              ...state.rechargeInsights.data,
              [key]: action.payload,
            }
          : state.rechargeInsights.data;
      const loadingKeys =
        key != null ? { ...state.rechargeInsights.loadingKeys } : {};
      if (key != null && loadingKeys[key]) delete loadingKeys[key];
      const loading = Object.keys(loadingKeys).length > 0;
      return {
        ...state,
        rechargeInsights: {
          loading,
          error: null,
          data: newData,
          loadingKeys,
        },
      };
    }

    case GET_RECHARGE_INSIGHTS_API_FAILED: {
      const key = action.extraData;
      const err = action.error;
      // UI makeAPICall treats 200 responses without message "SUCCESS" as failed and puts body in error.
      // If the "error" is actually the insights payload (array or object with content/trends/mtd_lmtd_points), store as data.
      const hasContentArray =
        typeof err?.content !== "undefined" && Array.isArray(err.content);
      const hasTrendsArray =
        typeof err?.trends !== "undefined" && Array.isArray(err.trends);
      const hasMtdLmtdPoints =
        typeof err?.mtd_lmtd_points !== "undefined" &&
        Array.isArray(err.mtd_lmtd_points);
      const isActuallySuccessPayload =
        key != null &&
        err != null &&
        typeof err === "object" &&
        !(err instanceof Error) &&
        (Array.isArray(err) ||
          hasContentArray ||
          hasTrendsArray ||
          hasMtdLmtdPoints);
      const payloadData = isActuallySuccessPayload ? err : null;
      const newData =
        key != null && payloadData !== null
          ? { ...state.rechargeInsights.data, [key]: payloadData }
          : state.rechargeInsights.data;
      const loadingKeys =
        key != null ? { ...state.rechargeInsights.loadingKeys } : {};
      if (key != null) delete loadingKeys[key];
      const loading = Object.keys(loadingKeys).length > 0;
      return {
        ...state,
        rechargeInsights: {
          loading,
          error: isActuallySuccessPayload ? null : err,
          data: newData,
          loadingKeys,
        },
      };
    }

    default:
      return state;
  }
}

export default rechargeSalesReducer;
